import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
    * {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      outline: none;

      &::before,
      &::after {
        box-sizing: border-box;
      }
    }
    
    html, body, #root {
      height: 100%;
      overflow-y: hidden;
    }
    
    input {
      -webkit-box-shadow: inset 0 0 0px 9999px transparent;
    }
  
    @-ms-viewport{
      width: device-width;
    }
  `

export default GlobalStyle
